/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Control_Track_Fade_In_LabelInputs */



/**
* | output |
* | --- |
* | "Fade down (ms)" |
*
* @param {Audio_Description_Export_Control_Track_Fade_In_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_control_track_fade_in_label = /** @type {((inputs?: Audio_Description_Export_Control_Track_Fade_In_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Control_Track_Fade_In_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Descente (ms)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Absenken (ms)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abbassamento (ms)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Приглушение (мс)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bajada (ms)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("淡出时长（ms）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フェードダウン（ms）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ेड डाउन (ms)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Descida (ms)")
	return /** @type {LocalizedString} */ ("Fade down (ms)")
});